import React, { useEffect, useState } from "react";
import { Container_List } from "../components/Container_List";
import request from "../../Helpers/API";
import Swal from "sweetalert2";

export const ProductoAliadoMainScreen = () => {
    const [cards, setCards] = useState([]);
    useEffect(() => {
        request
            .get(`MenuUsuarios/AccesosMenus?idmodulo=14`)
            .then((result) => {
                const cards_array = result.map((item) => ({
                    titulo: item.titulo,
                    ruta: item.ruta,
                }));
                localStorage.removeItem("filtroEstado");
                setCards(cards_array);
            })
            .catch((error) => {
                Swal.fire("MENUS PRODUCTO ALIADO", JSON.stringify(error), "error");
            });
    }, []);
    return <Container_List titulo={"CONFIGURACIONES DE PRODUCTO ALIADO"} cards={cards} />;
};
